import React, { useState } from 'react'
import Button from '../../../../utils/components/Button/Button'
import Input from '../../../../utils/components/Input/Input'
import { formatPrice, isNumeric } from '../../../../utils/functions'

const PaymentSummary = ({ total, register }) => {
    const [identification, setIdentification] = useState("")
    return (
        <div>
            total:{formatPrice(total)}
            <Input value={identification}  
                onChange =
                    {(e) => 
                        {
                            if(isNumeric(e.target.value))
                                {setIdentification(e.target.value)
                                }
                        }
                    } 
                placeholder='Identificación del cliente  ' />
            <Button text='Registrar' disabled={identification.length==0} onClick={() => register(identification)} />
        </div>
    )
}

export default PaymentSummary